import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItemAnchor from './MenuItemAnchor';
import omit from 'lodash/omit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import startsWith from 'lodash/startsWith';

function isVisible(user) {
    return !user.hasSubscription && user.isAuthenticated;
}

class Toolbar extends React.Component {

    constructor(props) {
        super(props);
        this.state = { open: false };
        this.ref = React.createRef();
    }

    render() {
        const {user} = this.props;
        if (!isVisible(user)) return null;

        return (<React.Fragment>
            {this.renderButton()}
            {this.renderMenu()}
        </React.Fragment>);
    }

    renderButton() {
        const isActive = (
            startsWith(window.location.pathname, '/member/') ||
            startsWith(window.location.pathname, '/premium/')
        );

        return (<a
            {...omit(this.props, 'user')}
            ref={this.ref}
            onClick={event => {
                event.preventDefault();
                this.setState({open: true});
            }}
            style={{
                ...this.props.style,
                borderBottomWidth: isActive ? 3 : 0,
                marginTop: isActive ? 3 : 0,
            }}>
            Membership
            <ExpandMoreIcon style={{fontSize: 18}} />
        </a>);
    }

    renderMenu() {
        return (<Menu
            anchorEl={this.ref.current}
            open={this.state.open}
            onClose={() => this.setState({open: false})}>
            <HamburgerMenu user={this.props.user} />
        </Menu>);
    }
}

function HamburgerMenu(props) {
    if (!isVisible(props.user)) return null;
    return (<React.Fragment>
        <MenuItemAnchor href="/member/">{gettext('Membership')}</MenuItemAnchor>
        <MenuItemAnchor href="/premium/">{gettext('Premium Membership')}</MenuItemAnchor>
    </React.Fragment>);
}

export default { Toolbar, HamburgerMenu };
